import {useEffect, useMemo, useState} from 'react';

import {useGoogleMapsAPI} from '@/components/global/providers/GoogleMapsProvider';
import {predictionToAddress} from '@/utils/googleAutocomplete';

type Address = ReturnType<typeof predictionToAddress>;

const useGoogleAutocomplete = (searchTerm: string): Address[] => {
  const {libraries} = useGoogleMapsAPI();
  const autocompleteService = useMemo(
    () =>
      libraries.places?.AutocompleteService ? new libraries.places.AutocompleteService() : null,
    [libraries.places],
  );
  const [autocompleteResults, setAutocompleteResults] = useState<Address[]>([]);

  useEffect(() => {
    if (searchTerm) {
      autocompleteService?.getPlacePredictions(
        {input: searchTerm, types: ['geocode'], componentRestrictions: {country: 'us'}},
        (predictions, status) => {
          if (status !== 'OK' || predictions == null) {
            setAutocompleteResults(currentResults =>
              currentResults.length === 0 ? currentResults : [],
            );
            return;
          }

          setAutocompleteResults(predictions.map(predictionToAddress));
        },
      );
    } else {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setAutocompleteResults(currentResults => (currentResults.length === 0 ? currentResults : []));
    }
  }, [searchTerm, autocompleteService]);

  return autocompleteResults;
};

export default useGoogleAutocomplete;
